import { render, staticRenderFns } from "./SearchTermReport.vue?vue&type=template&id=6b7ce5a6&scoped=true&"
import script from "./SearchTermReport.vue?vue&type=script&lang=js&"
export * from "./SearchTermReport.vue?vue&type=script&lang=js&"
import style0 from "./SearchTermReport.vue?vue&type=style&index=0&id=6b7ce5a6&lang=scss&scoped=true&"
import style1 from "./SearchTermReport.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b7ce5a6",
  null
  
)

export default component.exports